import {PIXI} from '@colonist/pixi'
import {isElement} from '../../ui_utils/Utils'
import {UIGameManager} from '../UIGameManager'
import {BaseAnimationWrapper} from './BaseAnimationWrapper'

export class OpacityAnimationWrapper extends BaseAnimationWrapper {
    private readonly object: PIXI.Container | HTMLElement

    constructor(object: PIXI.Container | HTMLElement, uiGameManager: UIGameManager, startValue: number, endValue: number, duration: number, startingDelay: number = 0) {
        super(uiGameManager, startValue, endValue, duration, startingDelay)
        this.object = object
        this.setValue(startValue)
    }

    protected setValue(alpha: number) {
        if(isElement(this.object)) {
            (this.object as HTMLElement).style.opacity = String(alpha)
        } else {
            const container = this.object as PIXI.Container
            if(container.destroyed) return
            container.alpha = alpha
        }
    }
}
